// ABOUTME: Application route constants
// ABOUTME: Centralized route definitions for type-safe navigation

export const ROUTES = {
  LANDING: '/',
  HOME: '/home',
  WARDROBE: '/wardrobe',
  SCANNER: '/scanner',
  OUTFIT_BUILDER: '/outfit-builder',
  EDUCATION: '/education',
  CHALLENGES: '/challenges',
  PROFILE: '/profile',
  PROGRESS: '/progress',
  INSIGHTS: '/insights',
  AVATAR: '/avatar',
  COLOR_PROFILE: '/color-profile',
  SHOP: '/shop',
  SUBSCRIPTION: '/subscription',
  LEADERBOARD: '/leaderboard',
  AI_COACH: '/ai-coach',
  AUTH: '/auth',
  ONBOARDING: '/onboarding',
} as const

export const ROUTE_TITLES: Record<string, string> = {
  [ROUTES.LANDING]: 'Gentlemen',
  [ROUTES.HOME]: "Gentleman's Academy",
  [ROUTES.WARDROBE]: 'Digital Wardrobe',
  [ROUTES.SCANNER]: 'Scan Item',
  [ROUTES.OUTFIT_BUILDER]: 'Outfit Builder',
  [ROUTES.EDUCATION]: 'Fashion Education',
  [ROUTES.CHALLENGES]: 'Daily Challenges',
  [ROUTES.PROFILE]: 'Your Profile',
  [ROUTES.PROGRESS]: 'Your Progress',
  [ROUTES.INSIGHTS]: 'Wardrobe Insights',
  [ROUTES.AVATAR]: 'Your Avatar',
  [ROUTES.COLOR_PROFILE]: 'Color Profile',
  [ROUTES.SHOP]: 'Shop',
  [ROUTES.SUBSCRIPTION]: 'Subscription',
  [ROUTES.LEADERBOARD]: 'Leaderboard',
  [ROUTES.AI_COACH]: 'AI Style Coach',
  [ROUTES.AUTH]: 'Sign In',
}

export const ROUTE_DESCRIPTIONS: Record<string, string> = {
  [ROUTES.LANDING]: 'Master the art of style through gamified learning',
  [ROUTES.HOME]: 'Master the art of style through gamified learning',
  [ROUTES.WARDROBE]: 'Manage your collection and create perfect outfits',
  [ROUTES.SCANNER]: 'Digitize your clothing collection',
  [ROUTES.EDUCATION]: 'Learn fashion through comprehensive courses',
  [ROUTES.CHALLENGES]: 'Complete challenges to earn XP and unlock rewards',
  [ROUTES.PROFILE]: 'Track your progress and achievements',
  [ROUTES.AUTH]: 'Sign in to your Gentleman account',
}

export function getRouteTitle(path: string): string {
  return ROUTE_TITLES[path] || "Gentleman's Academy"
}

export function getRouteDescription(path: string): string {
  return ROUTE_DESCRIPTIONS[path] || 'Master the art of style'
}
